"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderSelect_unstable", {
    enumerable: true,
    get: function() {
        return renderSelect_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reactutilities = require("@fluentui/react-utilities");
const renderSelect_unstable = (state)=>{
    (0, _reactutilities.assertSlots)(state);
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(state.root, {
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsx)(state.select, {
                children: state.select.children
            }),
            state.icon && /*#__PURE__*/ (0, _jsxruntime.jsx)(state.icon, {})
        ]
    });
};
